import clsx from "clsx";
import { Label } from "reactstrap";
import { InfoTooltip } from "../InfoTooltip/InfoTooltip";

interface FilterLabelProps {
  name: string;
  label?: string;
  tooltip?: string;
  className?: string;
}

export function FilterLabel({
  name,
  label,
  tooltip,
  className
}: Readonly<FilterLabelProps>) {
  const classNames = clsx("font-base-strong", className);

  return (
    <Label for={name} className={classNames}>
      {label}
      <InfoTooltip tooltip={tooltip} />
    </Label>
  );
}
